import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {ProductSupportWidgetComponent} from './product-support-widget.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {SafePipeModule} from '../../../pipes/safeResourceUrl/safeResourceUrl.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AnalyticsDirectivesModule} from '@app/directives/analytics/analytics-directives.module';

@NgModule({
  declarations: [
    ProductSupportWidgetComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductSupportWidgetComponent: {
          component: ProductSupportWidgetComponent,
        }
      }
    }),
    I18nModule,
    CommonModule,
    MatSidenavModule,
    BrowserAnimationsModule,
    SafePipeModule,
    AnalyticsDirectivesModule
  ],
  exports: [
    ProductSupportWidgetComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class ProductSupportWidgetModule {
}
